window.TSAvailabilityAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    var url = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.TSAttendanceBaseUrl : publicConfiguration.AttendanceBaseUrl;
    _protected.setApiUrl(url);

    /**
     * Get Employee's Availabilities
     * @param brandId
     * @param startDate
     * @returns {deferred.promise|{then, always}}
     */
    self.getEmployeeAvailability = function (brandId, startDate, availabilityType, availabilityStatus) {

        var deferred = $q.defer();

        var params = {
            brand_id: brandId,
            start_date: startDate,
            states: availabilityType,
            statuses: availabilityStatus
        };

        _protected.request("employees/availabilities/intervals", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Get Employee's Availability requests
     * @param brandId
     * @param startDate
     * @returns {deferred.promise|{then, always}}
     */
    self.getEmployeeAvailabilityRequests = function (brandId, status, offset, limit, states) {

        var deferred = $q.defer();

        var params = {
            brand_id: brandId,
            status: status,
            offset: offset || 0,
            limit: limit || 10,
            states: states
        };

        _protected.request("employees/availabilities", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };


    /**
     * Creates availability for the logged in user
     * @param data
     * @returns {deferred.promise|{then, always}}
     */
    self.createAvailability = function (data) {

        var deferred = $q.defer();

        _protected.request("employees/availabilities", "POST", data)
            .then(function (res) {
                if (res.data) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.checkAvailabilityWarningsEmployer = function (brandId, userId, params) {
        var deferred = $q.defer();
        _protected.request( "brands/" + brandId + "/users/" + userId + "/availabilities/check_warnings", "POST", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.checkAvailabilityWarningsEmployee = function (brandId, userId, params) {
        var deferred = $q.defer();
        _protected.request( "employees/brands/" + brandId + "/users/" + userId + "/availabilities/check_warnings", "POST", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.createAvailabilityRequestByEmployee = function (brandId, userId, payload) {

        var deferred = $q.defer();

        _protected.request( 'employees/brands/' + brandId + '/users/' + userId + '/availabilities', 'POST', payload)
            .then(function (res) {
                if (res.data) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.updateAvailabilityRequestByEmployee = function (brandId, userId, availabilityId, payload) {
        var deferred = $q.defer();

        _protected.request("employees/brands/" + brandId + "/users/" + userId + "/availabilities/" + availabilityId, "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                console.error(error);
                deferred.reject(error);
            });

        return deferred.promise;
    };

    // Employer creates availability for the specific user
    self.employerCreateAvailabilityForEmployee = function (brandId, payload) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/availabilities", "POST", payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.createAvailabilityRequestByEmployer = function (brandId, userId, payload) {
        var deferred = $q.defer();

        _protected.request( "brands/" + brandId + "/users/" + userId + "/availabilities", "POST", payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getTeamRequests = function (brandId, startDate, endDate, types) {
        if (!brandId) {
            throw new Error('Brand Id is required entity', Date.now());
        } else if (!startDate) {
            throw new Error('Start Date is required entity', Date.now());
        } else if (!endDate) {
            throw new Error('End Date is required entity', Date.now());
        }
        var deferred = $q.defer();

        var payLoad = {};
        payLoad['start_date'] = startDate;
        payLoad['end_date'] = endDate;
        payLoad['status'] = ['APPROVED', 'PENDING_APPROVAL', 'CLOSED', 'RETURNED_TO_WORK', 'OPEN'];

        if (types && types.length) {
            payLoad['types'] = types;
        }

        _protected.request("brands/" + brandId + "/requests", "GET", payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.data.requests) {
                    deferred.resolve(res.data.data.requests);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandAvailabilities = function (brandId, status, offset, limit, userId, sortBy, category, position, startingDate, states) {

        var deferred = $q.defer();

        var params = {
            status: status,
            offset: offset | 0,
            limit: limit | 10,
            user_id: userId,
            order_by: sortBy,
            category: category,
            position: position,
            starting_date: startingDate,
            states: states
        };

        _protected.request("brands/" + brandId + "/availabilities", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getBrandAvailabilitiesV2 = function (brandId, params) {
        var deferred = $q.defer();
        _protected.request(self.apiUrl.replace('v1', 'v2') + "brands/" + brandId + "/availabilities", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getAvailabilitiesSettingsEmployee = function (brandId) {
        var deferred = $q.defer();
        _protected.request( "employees/brands/" + brandId + "/availabilities/settings", "GET")
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getEmployeeAvailabilities = function (brandId, userId, params) {
        var deferred = $q.defer();
        _protected.request( "employees/brands/" + brandId + "/users/" + userId + "/availabilities", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getAvailabilityRequestDetails = function (brandId, requestId) {
        var deferred = $q.defer();
        _protected.request( "brands/" + brandId + "/availabilities/" + requestId, "GET")
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    self.getBrandAvailabilitiesCount = function(brandId, status, userId){

        var deferred = $q.defer(),
            params = {
                statuses: status,
                user_ids: userId,
            };

        _protected.request("brands/" + brandId + "/availabilities/notifications/counts", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Approve/reject availability request
     * @param brandId
     * @param availabilityId
     * @param status
     * @returns {deferred.promise|{then, always}}
     */
    self.manageEmployeeAvailability = function (brandId, availabilityId, status, rejectReason) {

        var deferred = $q.defer();
        var params = {
            status: status,
            rejection_reason: rejectReason
        };

        _protected.request("brands/" + brandId + "/availabilities/" + availabilityId, "PUT", params)
            .then(function (res) {
                if (res.data) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Get Employee's Availabilities Count
     * @param brandId
     * @param userId
     * @returns {deferred.promise|{then, always}}
     */
    self.getEmployeeAvailabilityCount = function (brandId, userId) {

        var deferred = $q.defer();

        var params = {
            user_id: userId,
	        status: "PENDING_APPROVAL"
        };

        _protected.request("brands/" + brandId + "/availabilities/count", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.request_count);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Get brand availability activities
     * @param brandId
     * @param userId
     * @returns {deferred.promise|{then, always}}
     */
    self.getBrandAvailabilityActivity = function (brandId, status, offset, limit, userId) {

        var deferred = $q.defer();

        var params = {
            status: status,
            offset: offset | 0,
            limit: limit | 10
        };

        if (userId) {
            params.user_id = userId;
        }

        _protected.request("brands/" + brandId + "/availabilities", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Remove availability request [Employee side]
     * @param availabilityId
     * @param status
     * @returns {deferred.promise|{then, always}}
     */
    self.deleteEmployeeAvailability = function (availabilityId) {

        var deferred = $q.defer();

        _protected.request("employees/availabilities/" + availabilityId , "DELETE")
            .then(function (res) {
                if (res.data) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Load availabilities to be used in scheduler
     */
    self.getScheduleAvailabilities = function (brandId, startDate, endDate) {
        var deferred = $q.defer();

        var payload = {
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD")
        };

        _protected.request(self.apiUrl.replace('v1', 'v2') + "brands/" + brandId + "/requests/intervals" , "GET", payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getBrandAbsencesCount = function (brandId, types, statuses) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/absences/notifications/counts", "GET", { types: types, statuses: statuses })
            .then(function (res) {
                if (res.data && res.data.data) {
                    var counts = {
                        sickness: {},
                        holiday: {},
                        time_off: {},
                        custom: {}
                    };
                    for (var i in res.data.data.counts) {
                        if (res.data.data.counts[i].type == "SICKNESS") {
                            counts.sickness.activityCount = res.data.data.counts[i].activity_count;
                            counts.sickness.requestCount = res.data.data.counts[i].request_count;
                        }
                        if (res.data.data.counts[i].type == "HOLIDAY") {
                            counts.holiday.activityCount = res.data.data.counts[i].activity_count;
                            counts.holiday.requestCount = res.data.data.counts[i].request_count;
                        }
                        if (
                            res.data.data.counts[i].type == "CUSTOM" ||
                            res.data.data.counts[i].type == "PATERNITY" ||
                            res.data.data.counts[i].type == "BEREAVEMENT" ||
                            res.data.data.counts[i].type == "MATERNITY" ||
                            res.data.data.counts[i].type == "SHARED_PARENTAL" ||
                            res.data.data.counts[i].type == "ADOPTION"
                        ) {
                            counts.custom.activityCount = counts.custom.activityCount || 0;
                            counts.custom.requestCount = counts.custom.requestCount || 0;
                            counts.custom.activityCount += (res.data.data.counts[i].activity_count || 0);
                            counts.custom.requestCount += (res.data.data.counts[i].request_count || 0);
                        }
                        if (res.data.data.counts[i].type == "TIME_OFF") {
                            counts.time_off.activityCount = res.data.data.counts[i].activity_count;
                            counts.time_off.requestCount = res.data.data.counts[i].request_count;
                        }
                    }
                    deferred.resolve(counts);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Get all brand's notifications' counts
     * @param brandId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getBrandAvailabilityCount = function (brandId, statuses) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/availabilities/notifications/counts", "GET", { statuses: statuses })
            .then(function (res) {
                if (res.data && res.data.data) {
                    var counts = {
                        availability: {}
                    };
                    for (var i in res.data.data) {
                        if (res.data.data[i].type == "AVAILABILITY") {
                            counts.availability.activityCount = res.data.data[i].activity_count;
                            counts.availability.requestCount = res.data.data[i].request_count;
                        }
                    }
                    deferred.resolve(counts);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Get all employee's notifications' counts
     * @param brandId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getEmployeeNotificationsCount = function (brand) {

        var deferred = $q.defer();
        var types = ['HOLIDAY', 'CUSTOM', 'AVAILABILITY', 'TIME_OFF', "PATERNITY", "BEREAVEMENT", "MATERNITY", "SHARED_PARENTAL", "ADOPTION"];

        var params = {
            brand_id: brand.id,
            types: [],
            statuses: ['APPROVED']
        };

        for (var i in types) {
            if (brand.absences && brand.absences.indexOf(types[i]) > -1) {
                params["types"].push(types[i]);
            }
        }

        _protected.request("employees/brands/" + brand.id + "/absences/notifications/counts", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    var counts = {
                        timeOff: {},
                        availability: {},
                        offer: {}
                    };
                    for (var i in res.data.data.counts) {
                        if (res.data.data.counts[i].type == "ONE_TIME") {
                            counts.timeOff.requestCount = res.data.data.counts[i].request_count;
                            counts.timeOff.activityCount = res.data.data.counts[i].activity_count;
                        }
                        else if (res.data.data.counts[i].type == "AVAILABILITY") {
                            counts.availability.activityCount = res.data.data.counts[i].activity_count;
                            counts.availability.requestCount = res.data.data.counts[i].request_count;
                        }
                        else if (res.data.data.counts[i].type == "OFFER") {
                            counts.offer.activityCount = res.data.data.counts[i].activity_count;
                            counts.offer.requestCount = res.data.data.counts[i].request_count;
                        }
                    }
                    deferred.resolve(counts);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

};


TSAvailabilityAPI.AVAILABILITY_STATUS = {
    PENDING_APPROVAL: "PENDING_APPROVAL",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    DELETED: "DELETED",
    WITHDRAWN: "WITHDRAWN",
    INVALID: "INVALID"
};

TSAvailabilityAPI.AVAILABILITY_STATES = {
    'AVAILABLE': 'AVAILABLE',
    'UNAVAILABLE': 'UNAVAILABLE',
    'PREFERRED_TIME': 'PREFERRED_TIME'
};
